export class ProductsActions {
  static readonly LOAD_REQUEST = 'pos/products/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'pos/products/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'pos/products/LOAD_ERROR';
  static readonly LOAD_LIST_SUCCESS = 'pos/products/LOAD_LIST_SUCCESS';
  static readonly SET_CURRENT_PAGE = 'pos/products/SET_CURRENT_PAGE';
}

export class SaleActions {
  static readonly LOAD_REQUEST = 'pos/sale/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'pos/sale/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'pos/sale/LOAD_ERROR';
  static readonly LOAD_LIST_SUCCESS = 'pos/sale/LOAD_LIST_SUCCESS';
  static readonly SET_CURRENT_PAGE = 'pos/sale/SET_CURRENT_PAGE';
}

export class SalesTotalsActions {
  static readonly LOAD_REQUEST = 'pos/salesTotals/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'pos/salesTotals/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'pos/salesTotals/LOAD_ERROR';
}

export class AdditionalFieldActions {
  static readonly LOAD_REQUEST = 'pos/additionalField/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'pos/additionalField/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'pos/additionalField/LOAD_ERROR';
  static readonly LOAD_LIST_SUCCESS = 'pos/additionalField/LOAD_LIST_SUCCESS';
  static readonly SET_CURRENT_PAGE = 'pos/additionalField/SET_CURRENT_PAGE';
}
